// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Wrapper class per the \`div.page article/aside/section\` global-selector gotcha in AGENTS.md:
 * scope every rule under \`.storefront-analytics\` so the dashboard's unscoped descendant
 * selectors don't style these sections unexpectedly.
 */
.storefront-analytics {
    display: grid;
    gap: 2rem;
}

.storefront-analytics__controls {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    padding: 1rem;
    background: var(--color-bg, #fff);
    border: 1px solid color-mix(in srgb, currentColor 14%, transparent);
    border-radius: 0.75rem;
}

.storefront-analytics__controls label {
    display: grid;
    gap: 0.35rem;
    font-size: 0.85rem;
}

.storefront-analytics__controls label span {
    color: #66736d;
    font-weight: 700;
}

.storefront-analytics__section {
    display: grid;
    gap: 0.5rem;
}

.storefront-analytics__section h2 {
    margin: 0;
}

.storefront-analytics__blurb {
    margin: 0;
    color: #66736d;
}

.storefront-analytics__empty {
    margin: 0;
    padding: 1.5rem 1rem;
    text-align: center;
    color: #66736d;
    background: color-mix(in srgb, currentColor 6%, transparent);
    border-radius: 0.5rem;
}

.storefront-analytics__state {
    padding: 1.5rem 1rem;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Analytics/StorefrontAnalytics.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,aAAa;IACb,iCAAiC;IACjC,mEAAmE;IACnE,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,4DAA4D;IAC5D,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB","sourcesContent":["/*\n * Wrapper class per the `div.page article/aside/section` global-selector gotcha in AGENTS.md:\n * scope every rule under `.storefront-analytics` so the dashboard's unscoped descendant\n * selectors don't style these sections unexpectedly.\n */\n.storefront-analytics {\n    display: grid;\n    gap: 2rem;\n}\n\n.storefront-analytics__controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1.5rem;\n    padding: 1rem;\n    background: var(--color-bg, #fff);\n    border: 1px solid color-mix(in srgb, currentColor 14%, transparent);\n    border-radius: 0.75rem;\n}\n\n.storefront-analytics__controls label {\n    display: grid;\n    gap: 0.35rem;\n    font-size: 0.85rem;\n}\n\n.storefront-analytics__controls label span {\n    color: #66736d;\n    font-weight: 700;\n}\n\n.storefront-analytics__section {\n    display: grid;\n    gap: 0.5rem;\n}\n\n.storefront-analytics__section h2 {\n    margin: 0;\n}\n\n.storefront-analytics__blurb {\n    margin: 0;\n    color: #66736d;\n}\n\n.storefront-analytics__empty {\n    margin: 0;\n    padding: 1.5rem 1rem;\n    text-align: center;\n    color: #66736d;\n    background: color-mix(in srgb, currentColor 6%, transparent);\n    border-radius: 0.5rem;\n}\n\n.storefront-analytics__state {\n    padding: 1.5rem 1rem;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
